var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"performance-activities-cards-total-spend"},[_c('WalletSecondary',{attrs:{"cards":_vm.translatedCards,"useSpaceBetweenPrefixAndValue":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }